import { render, staticRenderFns } from "./TestingForm.vue?vue&type=template&id=a7d8a8e0&scoped=true&"
import script from "./TestingForm.vue?vue&type=script&lang=js&"
export * from "./TestingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d8a8e0",
  null
  
)

export default component.exports